module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_vm._m(0), _vm._v(" "), _c('NonChromeWarning'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_c('a', {
    staticClass: "quickstart-action new-floorplan",
    on: {
      "click": function($event) {
        _vm.mapEnabled = false;
        _vm.mapVisible = false;
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("New")]), _vm._v(" "), _c('QuickstartIconNewFloorplan'), _vm._v(" "), _c('div', {
    staticClass: "explanation"
  }, [_vm._v("Create a new floorplan")])], 1)]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "quickstart-action",
    attrs: {
      "disabled": !_vm.online
    },
    on: {
      "click": function($event) {
        _vm.mapEnabled = true;
        _vm.tool = 'Map';
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("New With Map")]), _vm._v(" "), _c('QuickstartIconNewMapFloorplan'), _vm._v(" "), _c('div', {
    staticClass: "explanation"
  }, [_vm._v("Create a new floorplan with a map")])], 1)]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "quickstart-action open-floorplan",
    attrs: {
      "id": "import"
    },
    on: {
      "click": function($event) {
        _vm.$refs.importInput.click()
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Open")]), _vm._v(" "), _c('QuickstartIconOpenFloorplan'), _vm._v(" "), _c('div', {
    staticClass: "explanation"
  }, [_vm._v("Open an existing floorplan")])], 1)]), _vm._v(" "), _c('input', {
    ref: "importInput",
    attrs: {
      "id": "importInput",
      "type": "file"
    },
    on: {
      "change": _vm.importFloorplanAsFile
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_vm._v("Quickstart")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d56d6c28!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/MapModal.vue
// module id = 763
// module chunks = 2